import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import "./App.css";
import { gql, useLazyQuery } from "@apollo/client";
// import NavBar from "./components/menu/NavBar";
import Login from "./pages/login/Login";
import Logout from "./pages/Logout";
import { LoadingWLogo } from "./components/LoadingWLogo";
import { ModalError } from "./components/ModalError";
import ProfilePage from "./pages/ProfilePage";
import LoginVerify from "./pages/login/LoginVerify";
import WorkPage from "./pages/WorkPage";
import VerifiedExam from "./pages/VerifiedExam";

const isLogin_Query = gql`
  query LoginQuery{
    getUserData{
        _id
        Mobile
        Email
        FName
        LName
        Code
        Hogog_CodPer
        Per_CODBIM
        Avatar
    }
  }
`;

function App(props) {
  const [errors, setErrors] = useState({});

  const [user, setUser] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token-pod"));
  // const [token, setToken] = useState('');
  const [isLoginQuery, { data, loading }] = useLazyQuery(
    isLogin_Query,
    {
      onCompleted: updateData,
      fetchPolicy: "network-only",
      onError: errorFunc,
    }
  );
  useEffect(() => {
    isLoginQuery();
    // isLogin()
    // eslint-disable-line no-eval
  }, [isLoginQuery]);

  function updateError({ text, time, type }) {
    setErrors({
      text: text,
      time: time,
      type: type,
    });
  }

  function errorFunc(event) {
    setToken(false);
    setUser(false);
  }
  function isLogin() {
    console.log("update login");
    setToken(localStorage.getItem("token-pod"));
    isLoginQuery();
    // console.log(result);
  }
  function updateData(event) {
    if(data.getUserData){
      let userData = { ...data.getUserData };
    //   localStorage.setItem("token-pod", data.getUserData.Token);
    //   setToken(data.getUserData.Token);
    //   userData.Token = "";
      localStorage.setItem("user-lotus", JSON.stringify(userData));
      setUser(userData);
    }
  }
  if (loading) {
    return <LoadingWLogo />;
  }

  // if user is'nt loged in and sign up process
  if (!token) {
    return (
      <Router>
        <Switch>
          <Route
            exact
            path={`/`}
            render={(props) => (
              <Login
                {...props}
                user={user}
                updateLogin={isLogin}
                updateError={updateError}
              />
            )}
          />
          <Route
            exact
            path={`/verify`}
            render={(props) => (
              <LoginVerify
                {...props}
                user={user}
                updateLogin={isLogin}
                updateError={updateError}
              />
            )}
          />
          <Route render={(props) => <Redirect to={"/"} />} />
        </Switch>
        <Route
          path={"/"}
          render={(props) => (
            <ModalError {...props} errors={errors} updateError={updateError} />
          )}
        />
      </Router>
    );
  }

  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route
            path={`/work`}
            render={(props) => (
              <WorkPage
                {...props} 
                userdata={user} 
                errors={errors}
                updateLogin={isLogin}
                updateError={updateError} 
              />
            )}
          />
          <Route
            path={`/verified-exam/:id`}
            render={(props) => (
              <VerifiedExam
                {...props} 
                userdata={user} 
                errors={errors}
                updateLogin={isLogin}
                updateError={updateError} 
              />
            )}
          />
          <Route
            path={`/profile`}
            render={(props) => (
              <ProfilePage
                {...props}
                userdata={user}
                errors={errors}
                updateLogin={isLogin}
                updateError={updateError}
              />
            )}
          />
          <Route
            exact
            path={`/logout`}
            render={(props) => <Logout {...props} updateLogin={isLogin} />}
          />
          <Route render={(props) => <Redirect to={"/work"} />} />
        </Switch>
        <Route
          path={"/"}
          render={(props) => (
            <ModalError {...props} errors={errors} updateError={updateError} />
          )}
        />
      </Router>
    </React.Fragment>
  );
}
export default App;
